export default {
  /**
   * @param {HTMLElement} el - The target element
   * @param {Object} context - The context for the directive configuration
   * @param {Function} context.value - The click handler for the directive
   * @description The handler for the directive for the before mount hook
   */
  beforeMount(el, { value }) {
    const clickOutsideHandler = (e) => {
      if (!el.contains(e.target) && el !== e.target) {
        if (typeof value === 'function') value(e)
      }
    }

    el.clickOutsideHandler = clickOutsideHandler
    document.addEventListener('click', clickOutsideHandler)
  },

  /**
   * @param {HTMLElement} el - The target element
   * @description The handler for the directive for the before unmount hook
   */
  beforeUnmount(el) {
    el.removeEventListener('click', el.clickOutsideHandler)
  },
}
